<template>
  <div class="index-chart">
    <el-row>
      <el-col :span="5">
        <div class="index-cate">
          <div class="total-index">总指数</div>
          <div class="index-name" :class="{active:activeId==index}" v-for="(item, index) in indexData.index" :key="item" @click="changeIndex(index)">{{$filters.wholeReplace(item.name,'武安小米','')}}</div>
          <!-- <div class="index-introduce" @click="showIntroduce">
            指数介绍
          </div> -->
        </div>

      </el-col>
      <el-col :span="19">
        <div class="chart" ref="chartRef"></div>
      </el-col>
    </el-row>
    <el-dialog v-model="open" lock-scroll custom-class="dialog-style" title="指数介绍" width="70%">
      <div class="content" v-html="introduce.content"></div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { onMounted, ref, markRaw, computed, defineComponent, watch } from 'vue'
import MarkIcon from '@/assets/images/symbol.png'
import { siteCode, articleId } from '@/utils/data.js'
import Index from '@/views/common/index.js'
import { useStore } from 'vuex'
import { getArticle, getArticleList } from '@/api/article.js'

export default defineComponent({
  setup () {
    // vuex
    const store = useStore()
    // 当前激活的id
    const activeId = ref(null)
    // 数据图chart
    const chart = ref({})
    // 数据图ref
    const chartRef = ref()
    // 折线图拐点图标
    const markIcon = ref(MarkIcon)
    // 弹出框
    const open = ref(false)
    // 指数介绍id
    const introduceId = ref(articleId.introduceId)
    // 指数介绍数据
    const introduce = ref({})
    // 指数切换定时器
    const timer = ref(null)

    /** 从vuex中获取指数数据 */
    const indexData = computed(() => {
      return {
        index: [...store.getters.index]
      }
    })
    watch(() => indexData, (newVal) => {
      if (newVal.value.index && newVal.value.index.length > 0) {
        activeId.value = 0
        indexSetIntervalChange()
      }
    }, { deep: true, immediate: true })

    watch(() => activeId, (newVal, oldVal) => {
      if (newVal.value !== null) {
        chart.value && setChart(indexData.value.index[newVal.value].data)
      }
    }, { deep: true, immediate: true })

    /** 初始化 */
    const init = () => {
      // 获取指数数据
      const index = new Index(siteCode)
      index.getIndxData().then(() => {
        store.dispatch('data/setIndexData', index.indexStruct)
        store.dispatch('setting/setLoading', false)
      })
    }

    /** 切换指数 */
    const changeIndex = (id) => {
      activeId.value = id
    }

    /** 指数定时切换 */
    const indexSetIntervalChange = () => {
      timer.value && clearInterval(timer.value)
      const len = indexData.value.index.length
      timer.value = setInterval(() => {
        activeId.value++
        activeId.value = activeId.value % len
      }, 10000)
    }
    /** 展示数据图 */
    const setChart = (data) => {
      chart.value = markRaw(echarts.init(chartRef.value))
      chart.value.clear()
      const option = {
        tooltip: {
          trigger: "axis",
        },
        grid: {
          top: 30,
          left: 30,
          bottom: 30,
          right: 20
        },
        xAxis: {
          type: 'category',
          data: data.xData,
          axisTick: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            lineStyle: {
              color: '#727272',
              type: 'dotted'
            }
          },
          min: 40
        },
        series: [
          {
            data: data.yData,
            type: 'line',
            symbol: 'image://' + markIcon.value,
            symbolSize: '15',
            showAllSymbol: true,
            lineStyle: {
              color: 'rgba(59, 124, 228, 1)',
              width: 2,
              type: 'dotted'
            },
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(65, 121, 211, 0.4700)'
                },
                {
                  offset: 1,
                  color: 'rgba(105, 155, 230, 0)'
                }
              ])
            }
          }
        ]
      }
      chart.value.setOption(option)
    }

    /** 弹出层的显示 */
    const showIntroduce = () => {
      getIntroduce()
    }

    /** 获取指数介绍列表 */
    const getIntroduce = () => {
      getArticleList({
        typeId: introduceId.value,
        pageNo: 1,
        pageSize: 1
      }).then(res => {
        if (res.data.length > 0) {
          getArticle(res.data[0].id).then(response => {
            introduce.value = response.data
            open.value = true
          })
        }
      })
    }
    onMounted(() => {
      init()
    })
    return {
      indexData,
      chartRef,
      changeIndex,
      activeId,
      open,
      showIntroduce,
      introduce
    }
  }
})

</script>

<style lang="scss" scoped>
.index-chart{
  margin: 20px 0;
  height: 310px;
  background: #092E5F;
  font-family: YouSheBiaoTiHei;
  padding: 10px;
  >.el-row{
    height: 100%;
    >.el-col{
      height: 100%;
    }
  }
  .index-cate{
    position: relative;
    text-align: center;
    padding: 0 10px;
    letter-spacing: 1px;
    height: 100%;
    .total-index{
      font-size: 18px;
      font-family: YouSheBiaoTiHei;
    }
    .index-name{
      margin-top: 10px;
      font-size: 15px;
      padding: 5px 0;
      font-family: YouSheBiaoTiHei;
      cursor: pointer;
    }
    .active{
      background: #AF6C43;
      border-radius: 5px;
    }
    .index-introduce{
      position: absolute;
      bottom: 0;
      left: 0;
      background: #0F3D7A;
      border: 1px solid #3B7CE4;
      padding: 10px 25px 10px 15px;
      font-family: YouSheBiaoTiHei;
      cursor: pointer;
      &::after{
        content: '';
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 20px;
        height: 15px;
        background: url('~@/assets/images/introduce-icon.svg');
        background-size: 100% 100%;
      }
    }
  }
  .chart{
    width: 100%;
    height: 100%;
  }
}
</style>
